import { environmentDefaults } from './environment-defaults';
import { API_ENDPOINTS } from './api-endpoints';
import * as defaultsDeep from 'lodash.defaultsdeep';

const featureFlags = {
  OCA_SUBMITTED: true,
  PLATE_TRANSFER: false,
  PLATE_TRANSFER_NEW_UI: true,
  SIMULATE_PAYMENTS: true,
  NEW_VEHICLE: true,
  SHARE_OCA: true,
  LOG: true,
  CHAT: true,
  SIGNAL: true,
  SECURITYDEPOSITE_UI : true,
  TOTALOFPAYMENTS_UI: true,
  CARS_DEALER_UI: true,
  DEALER_FUNDED: true,
  TRADE_SIGNAL: true,
  TRADE_TAX_SAVINGS:true,
  PAYMENT_STREAM :true,
  PAYMENT_STREAM_FINANCE_CASH :false,
  QR_CODE:false,
  DAYS_TO_FIRST:false,
  PREVIOUS_RENTAL: false,
  SET_DEALER_CASH: true,
  ISPRESOLD_ENABLED: true,
  RELEASE_NOTES: true,
  DUPLICATE_CASHDOWN: true,
  RESIDUAL_PERCENTAGE: true,
  CONFIGURABLE_PRICING_PDF: true,
  ENABLE_TFMV: true, // Texas Fair Market Value Deduction (TFMV)
  NEXUS_TOYOTA_DOMAIN: true,
}

const override = {
  DESKING: API_ENDPOINTS.DESKING.TEST,
  hostname: API_ENDPOINTS.HOSTNAME.TEST,
  production: API_ENDPOINTS.ISPRODUCTION.TEST,
  DIS_URL: API_ENDPOINTS.DIS_URL.TEST,
  BASE_SERVICE_URL: API_ENDPOINTS.BASE_SERVICE_URL.TEST,
  PRESOLD_BASE_SERVICE_URL: API_ENDPOINTS.PRESOLD_BASE_SERVICE_URL.TEST,
  USED_VEHICLE_BASE_SERVICE_URL: API_ENDPOINTS.USED_VEHICLE_BASE_SERVICE_URL.TEST,
  POST_LOGOUT_REDIRECT_URL: API_ENDPOINTS.POST_LOGOUT_REDIRECT_URL.TEST,
  ENV: API_ENDPOINTS.ENV.TEST,//(PROD || TEST || QA || TEST || STAGE) ? JSON.stringify('production') : JSON.stringify('development') ,
  STORE_DEV_TOOLS: API_ENDPOINTS.STORE_DEV_TOOLS.TEST,
  MIN_LOG_LEVEL: API_ENDPOINTS.MIN_LOG_LEVEL.TEST,
  ACTUAL_ENV: API_ENDPOINTS.ACTUAL_ENV.TEST,//PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : TEST ? JSON.stringify('TEST') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: API_ENDPOINTS.EFC_URL.TEST,
  AUTH_BASE_URL: API_ENDPOINTS.AUTH_BASE_URL.TEST,
  SILENT_REDIRECT_URL: API_ENDPOINTS.SILENT_REDIRECT_URL.TEST,
  CONSUMER_PREVIEW_ENDPOINT: API_ENDPOINTS.CONSUMER_PREVIEW_ENDPOINT.TEST,
  MST_BASE_SERVICE_URL: API_ENDPOINTS.MST_BASE_SERVICE_URL.TEST,
  DG_BASE_SERVICE_URL: API_ENDPOINTS.DG_BASE_SERVICE_URL.TEST,
  SOCKET_ENDPOINT: API_ENDPOINTS.SOCKET_ENDPOINT.TEST,
  VSPEC_GUEST_PORTAL: API_ENDPOINTS.VSPEC_GUEST_PORTAL.TEST,
  CREDIT_APP_URL: API_ENDPOINTS.CREDIT_APP_URL.TEST,
  ENGAGE_MATERIAL_URL: API_ENDPOINTS.ENGAGE_MATERIAL_URL.TEST,
  ENGAGE_MATERIAL_LEXUS_URL: API_ENDPOINTS.ENGAGE_MATERIAL_LEXUS_URL.TEST,
  MST_CONSOLE: API_ENDPOINTS.MST_CONSOLE.TEST,
  AUTH_AUTHORITY: API_ENDPOINTS.AUTH_AUTHORITY.TEST,
  AUTHORIZATION_ENDPOINT: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.TEST,
  ISSUER: API_ENDPOINTS.ISSUER.TEST,
  JWTURI: API_ENDPOINTS.JWTURI.TEST,
  AUTHORITY: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.TEST,
  CLIENT_ID: API_ENDPOINTS.CLIENT_ID.TEST,
  FEATURE_FLAGS: featureFlags,
  SIGNAL_URL: API_ENDPOINTS.SIGNAL.TEST,
  TRADE_SIGNAL_URL: API_ENDPOINTS.TRADE_SIGNAL_ENDPOINT.TEST
};

export const environment = defaultsDeep(override, environmentDefaults);
